// VAT Switch Script - Adapted for Neat Theme
// Handles VAT toggle for product prices, cart, and bundle app

var vatSelectorInput1 = document.querySelector('#vat_select_wrapper1 input[name="vat-toggle"]');
var vatSelectorInput2 = document.querySelector('#vat_select_wrapper2 input[name="vat-toggle"]');
var isVatApplied;
const vatPercentage = 1.21;

// Initialize on DOM ready
document.addEventListener("DOMContentLoaded", function () {
  vatSelectorInput1 = document.querySelector('#vat_select_wrapper1 input[name="vat-toggle"]');
  vatSelectorInput2 = document.querySelector('#vat_select_wrapper2 input[name="vat-toggle"]');
  
  setTimeout(() => {
    // Only initialize if at least one VAT switch is enabled
    const vatSwitchEnabled = document.getElementById('vat_select_wrapper1') || document.getElementById('vat_select_wrapper2');
    
    if (!vatSwitchEnabled) {
      // VAT switch is disabled in theme settings, mark as ready and exit
      document.body.classList.add('vat-ready');
      return;
    }
    
    // Add event listeners to both switches
    if (vatSelectorInput1) {
      vatSelectorInput1.addEventListener('input', updatePrices);
    }
    if (vatSelectorInput2) {
      vatSelectorInput2.addEventListener('input', updatePrices);
    }
    
    applySavedPreference();
  }, 500);
});

// Listen for cart updates
document.addEventListener('cart:updated', function(event) {
  // Only apply if VAT switch is enabled
  if (document.getElementById('vat_select_wrapper1') || document.getElementById('vat_select_wrapper2')) {
    applySavedPreference();
  }
});

// Main update function
function updatePrices(event) {
  // Double-check VAT switch is still enabled
  if (!document.getElementById('vat_select_wrapper1') && !document.getElementById('vat_select_wrapper2')) return;
  
  isVatApplied = event?.target?.checked ?? event ?? false;
  saveCookie(isVatApplied);
  
  // Sync both switches
  if (vatSelectorInput1 && vatSelectorInput1 !== event?.target) {
    vatSelectorInput1.checked = isVatApplied;
  }
  if (vatSelectorInput2 && vatSelectorInput2 !== event?.target) {
    vatSelectorInput2.checked = isVatApplied;
  }

  const priceElements = getAllPriceElements();
  priceElements.forEach(el => applyVatOverlay(el));
}

// Get all price elements on the page
function getAllPriceElements() {
  const prices = [];
  
  prices.push(...document.querySelectorAll('.product-price .price'));
  prices.push(...document.querySelectorAll('.product-price .regular-price'));
  prices.push(...document.querySelectorAll('.unit-price'));
  prices.push(...document.querySelectorAll('.sub-total .total-price'));
  prices.push(...document.querySelectorAll('.dyn-cart-line-price, .dyn-money-format, .total-price, .supply-price'));
  
  return Array.from(new Set(prices)).filter(el => {
    const text = getCleanText(el);
    return text && (text.includes('€') || text.includes('$') || /[\d.,]+/.test(text));
  });
}

// Get clean text from element (excluding sr-only and overlay elements)
function getCleanText(el) {
  const clone = el.cloneNode(true);
  const srOnly = clone.querySelectorAll('.sr-only');
  srOnly.forEach(sr => sr.remove());
  const overlays = clone.querySelectorAll('.vat-overlay');
  overlays.forEach(ov => ov.remove());
  return clone.textContent.trim();
}

// Apply VAT overlay (non-destructive approach)
function applyVatOverlay(el) {
  let overlay = el.querySelector('.vat-overlay');
  let originalText;
  
  if (overlay) {
    const prevDisplay = overlay.style.display;
    overlay.style.display = 'none';
    originalText = getCleanText(el);
    overlay.style.display = prevDisplay;
  } else {
    originalText = getCleanText(el);
  }

  const currentPrice = parsePrice(originalText);
  if (isNaN(currentPrice)) return;

  // Check if element is in cart (exclude VAT text from cart)
  const isInCart = el.closest('.side-cart, .cart, .cart-drawer, [class*="cart"]');

  if (getComputedStyle(el).position === 'static') {
    el.style.position = 'relative';
  }

  if (!overlay) {
    overlay = document.createElement('span');
    overlay.className = 'vat-overlay';
    overlay.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;pointer-events:none;white-space:nowrap;background-color:inherit;color:#000000;';
  }

  if (isVatApplied) {
    // VAT is ON: multiply price and show overlay
    const adjustedPrice = currentPrice * vatPercentage;
    const formattedPrice = formatPrice(adjustedPrice);
    const parts = extractPrefixSuffix(originalText);
    
    if (isInCart) {
      overlay.innerHTML = parts.prefix + formattedPrice + parts.suffix;
    } else {
      const vatTextSpan = '<span class="vat-text">' + getVatText() + '</span>';
      overlay.innerHTML = parts.prefix + formattedPrice + parts.suffix + ' ' + vatTextSpan;
    }
    
    if (!overlay.isConnected) el.appendChild(overlay);
    
    if (!el.dataset.originalColor) {
      el.dataset.originalColor = getComputedStyle(el).color;
    }
    el.style.color = 'transparent';
    
    requestAnimationFrame(() => {
      if (overlay && el) {
        el.style.minWidth = '';
        const overlayWidth = overlay.offsetWidth;
        if (overlayWidth > 0) {
          el.style.minWidth = overlayWidth + 'px';
        }
      }
    });
  } else {
    // VAT is OFF: remove overlay and show original price
    if (overlay && overlay.parentNode === el) {
      overlay.remove();
    }
    if (el.dataset.originalColor) {
      el.style.color = el.dataset.originalColor;
    } else {
      el.style.color = '';
    }
    el.style.minWidth = '';
  }
}

// Parse price from text (handles European and US formats)
function parsePrice(text) {
  const match = text.match(/[\d.,]+/);
  if (!match) return NaN;
  
  const priceStr = match[0];
  let normalized;
  
  if (priceStr.includes(',') && priceStr.indexOf(',') > priceStr.length - 4) {
    normalized = priceStr.replace(/\./g, '').replace(',', '.');
  } else {
    normalized = priceStr.replace(/,/g, '');
  }
  
  return Number(normalized);
}

// Format price according to locale
function formatPrice(price) {
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(price);
}

// Get VAT text based on language
function getVatText() {
  const locale = (typeof Shopify !== 'undefined' && Shopify.locale) || document.documentElement.lang || 'nl';
  
  const translations = {
    nl: { excl: 'excl. BTW', incl: 'incl. BTW' },
    en: { excl: 'excl. VAT', incl: 'incl. VAT' },
    de: { excl: 'exkl. MwSt.', incl: 'inkl. MwSt.' }
  };
  
  const lang = locale.toLowerCase().substring(0, 2);
  const text = translations[lang] || translations.nl;
  
  return isVatApplied ? text.incl : text.excl;
}

// Extract prefix and suffix from price text
function extractPrefixSuffix(text) {
  const match = text.match(/[\d.,]+/);
  if (!match) return { prefix: '', suffix: '' };
  
  const start = match.index;
  const end = start + match[0].length;
  
  return {
    prefix: text.slice(0, start).trim() + ' ',
    suffix: ' ' + text.slice(end).trim()
  };
}

// Apply saved preference from cookie
function applySavedPreference() {
  const savedValue = getCookie('rememberVatTrueFalse');
  
  // Default to OFF (excl. VAT) when no cookie exists
  if (savedValue === 'true') {
    isVatApplied = true;
    if (vatSelectorInput1) vatSelectorInput1.checked = true;
    if (vatSelectorInput2) vatSelectorInput2.checked = true;
  } else {
    isVatApplied = false;
    if (vatSelectorInput1) vatSelectorInput1.checked = false;
    if (vatSelectorInput2) vatSelectorInput2.checked = false;
  }
  
  updatePrices({ target: { checked: isVatApplied } });
  
  // Mark body as ready to show prices
  document.body.classList.add('vat-ready');
}

// Save cookie
function saveCookie(value) {
  document.cookie = 'rememberVatTrueFalse=' + value + '; path=/; max-age=31536000';
}

// Get cookie value
function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const parts = cookie.split('=');
    if (parts[0] === name) return parts[1];
  }
  return null;
}

// Observer for cart drawer updates
function observeCartDrawer() {
  const cartContent = document.querySelector('.side-cart-content');
  if (!cartContent) return;

  let updateTimeout;
  const observer = new MutationObserver(() => {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(() => {
      const cartPrices = getAllPriceElements();
      cartPrices.forEach(el => applyVatOverlay(el));
    }, 100);
  });

  observer.observe(cartContent, { 
    childList: true, 
    subtree: true, 
    characterData: true 
  });
}

// Observer for Bundle app (if present)
function observeBundleApp() {
  const bundleWrapper = document.getElementById('dyn-product-options');
  if (!bundleWrapper) return;

  let updateTimeout;
  const observer = new MutationObserver(() => {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(() => {
      const bundlePrices = bundleWrapper.querySelectorAll('.total-price, .supply-price, .dyn-money-format');
      bundlePrices.forEach(el => applyVatOverlay(el));
    }, 100);
  });

  observer.observe(bundleWrapper, { 
    childList: true, 
    subtree: true, 
    characterData: true 
  });
}

// Handle variant changes
let variantChangeTimer;
function handleVariantChange() {
  clearTimeout(variantChangeTimer);
  variantChangeTimer = setTimeout(() => {
    const priceElements = getAllPriceElements();
    priceElements.forEach(el => applyVatOverlay(el));
  }, 100);
}

// Listen for variant changes
document.addEventListener('change', function(e) {
  if (e.target.matches('input[name^="options"], .product-variants input[type="radio"]')) {
    handleVariantChange();
  }
});

document.addEventListener('change', function(e) {
  if (e.target.matches('select[name^="options"], select.product-variants')) {
    handleVariantChange();
  }
});

// Check for theme-specific variant change events
if (window.theme && window.theme.pubsub) {
  try {
    theme.pubsub.subscribe('variant:change', handleVariantChange);
  } catch (e) {
    // Theme pubsub not available
  }
}

// Initialize observers
setTimeout(() => {
  observeCartDrawer();
  observeBundleApp();
}, 1000);

// Re-apply prices when navigating back
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    applySavedPreference();
  }
});